import { get } from "lodash";

export const getCurrentPlanAndInvoiceData = (stripeCustomerObj) => {
  const currentSubscription = stripeCustomerObj?.subscriptions?.data[0] || null;

  let planData = { isPaid: false };
  let invoiceData = {};

  // consider both 'active' *and* 'trialing' subscriptions
  if (
    currentSubscription?.status === "active" ||
    currentSubscription?.status === "trialing"
  ) {
    planData = {
      priceId: currentSubscription.plan.id,
      invoiceEmail: stripeCustomerObj.email,
      subscriptionId: currentSubscription.id,
      productId: currentSubscription.plan.product,
      renewalDate: currentSubscription.current_period_end,
      isInTrial: currentSubscription.status === "trialing",
      trialEndDate: currentSubscription.trial_end,
    };

    invoiceData = {
      isPaid: currentSubscription.latest_invoice,
      nextIssueDate: currentSubscription.current_period_end,
      invoiceTotal: `$${currentSubscription.latest_invoice.amount_due / 100}`,
      knowledgeWorkers: currentSubscription?.latest_invoice?.lines
        ? currentSubscription.latest_invoice.lines.data.slice(-1)[0].quantity
        : undefined,
    };
  } else if (stripeCustomerObj) {
    // if we have a customer and no active
    // subscription users can still edit email
    planData = { invoiceEmail: stripeCustomerObj.email };
  }

  return {
    planData,
    invoiceData,
  };
};

const isCreditCardInputOptDisabled = (product) => {
  // if we do not have a product, fall back to self-service
  // self-service users are able to sign up with their CC
  if (!product) return false;

  const segmentsToDisable = ["direct", "msp", "reseller", "referral"];
  return segmentsToDisable.includes(product.metadata.segment);
};

export const formatProducts = (prices, priceId, currentOrg = {}) => {
  const activePrice = prices.data.find((price) => price.id === priceId);
  const fullProduct = activePrice?.product ? activePrice.product : null;
  const targetProductSegment =
    currentOrg.market === 0 ? "direct" : "self-service";

  // filter prices/products based on segment metadata
  let activePrices = prices.data.filter(
    (price) => price.product.active === true
  );
  let filteredPrices = activePrices.filter((price) => {
    if (!fullProduct)
      return price.product.metadata.segment === targetProductSegment;
    return price.product.metadata.segment === fullProduct.metadata.segment;
  });

  let productOptionsToReturn = filteredPrices.map((priceObj) => ({
    priceId: priceObj.id,
    name: priceObj.product.name,
    productId: priceObj.product.id,
    description: priceObj.product.description,
    license: priceObj.product.metadata.license,
    billingPeriod: `${priceObj.recurring.interval || "month"}ly`,
    disableCreditCard: isCreditCardInputOptDisabled(fullProduct),
    amount: `${priceObj.unit_amount / 100}/${
      priceObj.recurring.interval || "month"
    }`, // price stored in cents i.e. 800 = $8
  }));

  return productOptionsToReturn;
};

/* 
    @handleShouldUpdateLicense
    based on the product the current org is subscribed to
    check if the licensing on the org matches said product
    and if not send back the proper license with which 
    to update the current org's config property
*/
export const handleShouldUpdateLicense = (prices, productId, currentOrg) => {
  const activePrice = prices.data.find(
    (price) => price.product.id === productId
  );
  const fullProduct = activePrice?.product ? activePrice.product : null;

  const metadataLicense = get(fullProduct, ["metadata", "license"], null);
  const currentOrgLicense = get(currentOrg, ["config", "license"], null);

  // if the licenses do not match or there
  // is not one existing on the org, update
  if (currentOrgLicense !== metadataLicense) return metadataLicense;

  return false;
};
